(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.re-new-investment.pdf
  (:require
   [frontend.ui.page.lp-portal.report.pdf.view :as pdf-report]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.card.pdf.view :as pdf-card]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.stacked-text-group.pdf.view :as stacked-text]
   [frontend.ui.component.chart.view :as chart-view]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.table.pdf.view :as pdf-table]))

(defn holding-pages
  [report-data]
  (let [kpi-count (->> report-data
                       :overview
                       :figures
                       :data
                       (remove nil?)
                       (count))]
    (concat [(page/page
              (page/third-column-background)
              (page/page-title {:page-title
                                (str (:holding-name report-data) " - new investment")
                                :toc-item   true})
              (column/columns-2-to-1
               (pdf-card/card
                "Investment overview"
                (text-content/rich-content (->> report-data
                                                :case-overview-text
                                                :rich-content)))
               {:margin [0 15 0 0]
                :stack  (concat [(pdf-table/dynamic-stack (-> report-data
                                                              :overview
                                                              :figures
                                                              (pdf-table/limit-dynamic-stack
                                                               (if (>= kpi-count 10)
                                                                 (int (Math/ceil (/ kpi-count 2)))
                                                                 14))))]
                                [(text-content/optional-footer (->> report-data
                                                                    :overview))]
                                (when (< kpi-count 10)
                                  [{:svg    (chart-view/geomap-svg "highcharts"
                                                                   (potpuri/deep-merge
                                                                    (-> report-data
                                                                        :map-data
                                                                        :figures)
                                                                    {:chart {:width  500
                                                                             :height 320}}))
                                    :width  (- page/page-width-one-third 46)
                                    :height 150}
                                   (text-content/optional-footer (-> report-data
                                                                     :map-data))]))}))]
            (when (> kpi-count 14)
              [(page/page
                (page/third-column-background)
                (page/page-title {:page-title (:holding-name report-data)})
                (column/columns-2-to-1
                 (column/column
                  {:svg   (chart-view/geomap-svg "highcharts"
                                                 (potpuri/deep-merge
                                                  (-> report-data
                                                      :map-data
                                                      :figures)
                                                  {:chart {:width  500
                                                           :height 320}}))
                   :width page/page-width-half}
                  (text-content/optional-footer (-> report-data
                                                    :map-data)))
                 {:margin [0 15 0 0]
                  :stack  (concat [(pdf-table/dynamic-stack (-> report-data
                                                                :overview
                                                                :figures
                                                                (pdf-table/continue-dynamic-stack
                                                                 (if (>= kpi-count 10)
                                                                   (int (Math/ceil (/ kpi-count 2)))
                                                                   14))))]
                                  [(text-content/optional-footer (->> report-data
                                                                      :overview))])}))]))))

(defn pdf-report
  [{:keys [reporting-period holding-name reference-date] :as view-data}]
  (pdf-report/report view-data
                     (holding-pages view-data)
                     holding-name
                     reporting-period
                     reference-date))
